import { render, staticRenderFns } from "./AssuranceRequirements.vue?vue&type=template&id=546051da"
import script from "./AssuranceRequirements.vue?vue&type=script&lang=js"
export * from "./AssuranceRequirements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports